import { Link } from 'react-router-dom';
import { useBranding } from '@/contexts/BrandingContext';
import { BrandMark } from '@/components/BrandLogo';

export function SidebarHeader() {
  const { branding: brandData } = useBranding();

  return (
    <div className="p-5 border-b border-white/10">
      <Link to="/" className="flex items-center space-x-2.5">
        <BrandMark onDark className="w-9 h-9" alt={brandData?.site_name || 'Estadía 365'} />
        <span className="font-semibold text-lg text-white" style={{ fontFamily: 'var(--font-heading, Outfit)' }}>
          {brandData?.site_name || 'Estadía 365'}
        </span>
      </Link>
    </div>
  );
}
